<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="200px" height="200px" viewBox="0 0 50 50" enable-background="new 0 0 50 50" xml:space="preserve">
    <g>
			<polygon points="25,47 22.4,49.6 20.5,46.5 17.4,48.5 16.1,45.1 12.7,46.4 12.1,42.8 8.5,43.4 8.7,39.7 5.1,39.5 6.1,36 2.5,35.1 4.2,31.8 0.9,30.1 3.3,27.3 0.4,25 3.3,22.7 0.9,19.9 4.2,18.2 2.5,14.9 6.1,14 5.1,10.5 8.7,10.3 8.5,6.6 12.1,7.2 12.7,3.6 16.1,4.9 17.4,1.5 20.5,3.5 22.4,0.4 25,3 27.6,0.4 29.5,3.5 32.6,1.5 33.9,4.9 37.3,3.6 37.9,7.2 41.5,6.6 41.3,10.3 44.9,10.5 43.9,14 47.5,14.9 45.8,18.2 49.1,19.9 46.7,22.7 49.6,25 46.7,27.3 49.1,30.1 45.8,31.8 47.5,35.1 43.9,36 44.9,39.5 41.3,39.7 41.5,43.4 37.9,42.8 37.3,46.4 33.9,45.1 32.6,48.5 29.5,46.5 27.6,49.6"/> 
      <!-- <path d="M27.529 0.798l1.669 2.615l0.273 0.428l0.424-0.28l2.583-1.706l1.093 2.907l0.178 0.475l0.473-0.185 L37.1 3.923l0.468 3.075l0.076 0.5l0.499-0.083l3.052-0.503l-0.179 3.107l-0.029 0.504l0.505 0.024l3.088 0.146l-0.816 3 l-0.132 0.486l0.486 0.128l2.993 0.79l-1.421 2.766l-0.23 0.448l0.449 0.227l2.765 1.398l-1.96 2.408l-0.317 0.39l0.392 0.3 L49.203 25l-2.416 1.944l-0.392 0.315l0.317 0.39l1.961 2.41l-2.766 1.399l-0.449 0.228l0.23 0.447l1.42 2.766l-2.991 0.8 l-0.488 0.128l0.133 0.486l0.817 3.003l-3.089 0.147l-0.505 0.023l0.029 0.504l0.179 3.104l-3.052-0.501l-0.499-0.082l-0.076 0.5 L37.1 46.074l-2.878-1.128l-0.473-0.185l-0.178 0.475l-1.093 2.909l-2.583-1.706l-0.424-0.28l-0.273 0.428l-1.669 2.6 l-2.173-2.208L25 46.632l-0.356 0.362l-2.173 2.208l-1.668-2.614l-0.273-0.429l-0.424 0.28l-2.583 1.706l-1.092-2.909l-0.178-0.475 l-0.473 0.185L12.9 46.075l-0.468-3.073l-0.076-0.5l-0.499 0.082l-3.05 0.501l0.177-3.104l0.029-0.504l-0.504-0.023L5.42 39.3 l0.818-3.002l0.132-0.487l-0.487-0.128l-2.992-0.789l1.419-2.766l0.229-0.447l-0.449-0.228L1.327 30.06l1.961-2.41l0.317-0.39 l-0.392-0.315L0.797 25l2.416-1.947l0.392-0.315l-0.317-0.39L1.327 19.94l2.764-1.398l0.449-0.227L4.31 17.867l-1.419-2.767 l2.992-0.79l0.487-0.128l-0.132-0.486L5.42 10.694l3.088-0.146l0.504-0.024l-0.029-0.504L8.807 6.913l3.05 0.503l0.5 0.1 l0.076-0.5L12.9 3.923l2.878 1.128l0.472 0.185l0.179-0.475l1.092-2.907l2.583 1.706l0.424 0.28l0.273-0.428l1.668-2.615 l2.173 2.208L25 3.368l0.356-0.362L27.529 0.8 M27.613 0L25 2.655L22.386 0L20.38 3.144l-3.106-2.051l-1.313 3.494L12.5 3.2 l-0.562 3.693L8.272 6.318l0.213 3.73l-3.711 0.175l0.981 3.604l-3.593 0.948l1.703 3.319l-3.318 1.679l2.353 2.89L0 25l2.9 2.3 l-2.353 2.892l3.318 1.68l-1.703 3.319l3.593 0.947l-0.981 3.604l3.711 0.177L8.272 43.68l3.666-0.603l0.562 3.691l3.461-1.356 l1.313 3.496l3.106-2.052L22.386 50L25 47.345L27.613 50l2.007-3.144l3.105 2.052l1.313-3.496l3.461 1.356l0.562-3.691l3.668 0.6 l-0.215-3.728l3.711-0.177l-0.98-3.604l3.594-0.947l-1.705-3.319l3.319-1.68l-2.353-2.892L50 25l-2.899-2.336l2.353-2.89 l-3.319-1.679l1.705-3.319l-3.594-0.948l0.98-3.604l-3.711-0.175l0.215-3.73l-3.668 0.604L37.5 3.229l-3.461 1.357l-1.313-3.494 L29.62 3.144L27.613 0L27.613 0z" /> -->
			
			<text 
				x="9"
				y="28" 
				fill="white" 
				font-family="d-din_condenseddinCnBd"
				font-size="0.8rem"
			>€</text>
			<text 
				x="16"
				y="33" 
				fill="white" 
				font-family="d-din_condenseddinCnBd"
				font-size="1.3rem"
			>{{ price }}</text>
			<text 
				x="16"
				y="33" 
				fill="white" 
				font-family="d-din_condenseddinCnBd"
				font-size="1.3rem"
			>{{ price }}</text>
			<text 
				x="34"
				y="25" 
				fill="white" 
				font-family="d-din_condenseddinCnBd"
				font-size="0.5rem"
			>,99</text>
		</g>
		<defs>
        <linearGradient id="grad" x2="0%" y2="100%">
            <stop offset="0" stop-color="#D32F2F"/>
            <stop offset="1" stop-color="#A81515"/>
        </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    price: {
      type: String,
      default: ""
    }
  }
}
</script>

<style>


@font-face {
    font-family: 'd-din_condenseddinCnBd';
    src: url('../assets/fonts/d-dincondensed-bold-webfont.woff2') format('woff2'),
         url('../assets/fonts/d-dincondensed-bold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

}

polygon {
	fill: url(#grad);
}

.price {
  font-size: 2rem;
  padding: 25px;
}
</style>